import React from 'react';

import LandingAgentBar, { MARKETING_AGENT_STICKY_ZONE_ID } from './LandingAgentBar';

export { MARKETING_AGENT_STICKY_ZONE_ID };

interface MarketingAgentBarProps {
  onNavigate?: (view: string) => void;
}

/** Compact agent search bar for marketing pages — sticky below the top nav. */
const MarketingAgentBar: React.FC<MarketingAgentBarProps> = () => (
  <LandingAgentBar
    stickyZoneId={MARKETING_AGENT_STICKY_ZONE_ID}
    releaseBeforeId={null}
    hideOnRelease={false}
  />
);

export default MarketingAgentBar;
